import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from '../components/ui/card';
import { ShieldAlert, LogOut, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const PendingConfirmation = () => {
  const { user, logout } = useAuth();
  const { language } = useLanguage();

  const isDe = language === 'de';

  if (!user) return null;

  return (
    <div className="auth-container">
      <Card className="auth-card border-none sm:border-solid shadow-none sm:shadow-md border-yellow-500/50 bg-yellow-500/5">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            {user?.email_verified ? (
              <div className="p-4 rounded-full bg-green-500/10">
                <CheckCircle2 className="w-12 h-12 text-green-600" />
              </div>
            ) : (
              <div className="p-4 rounded-full bg-yellow-500/20">
                <ShieldAlert className="w-12 h-12 text-yellow-600" />
              </div>
            )}
          </div>
          {user?.email_verified && (
            <CardTitle className="text-2xl font-bold text-green-600 dark:text-green-400 mb-2">
              {isDe ? 'E-Mail verifiziert!' : 'Email verified!'}
            </CardTitle>
          )}
          <CardTitle className="text-xl">
            {isDe ? 'Warten auf Bestätigung' : 'Awaiting Confirmation'}
          </CardTitle>
          <CardDescription className="text-sm mt-2">
            {isDe 
              ? 'Dein Account muss nun von einem Admin bestätigt werden, bevor du Zugriff auf die Plattform erhältst.' 
              : 'Your account must now be confirmed by an admin before you can access the platform.'}
          </CardDescription>
        </CardHeader>
        <CardFooter className="pt-4 flex flex-col gap-2">
          <Button variant="outline" className="h-11 rounded-xl flex items-center gap-2" onClick={logout}>
            <LogOut className="w-4 h-4" />
            {isDe ? 'Abmelden' : 'Logout'}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default PendingConfirmation;
